import { useAuth } from 'contexts/auth/auth-context'
import { Theme } from 'contexts/auth/types'
import React from 'react'
import { Button, ButtonThemeType, FontIcon, TextIconSpacing } from 'react-md'
import { usePromiseTracker } from 'react-promise-tracker'

interface Props {
  text?: string
  type?: ButtonThemeType
  disabled?: boolean
  onClick?: () => Promise<void>
  style?: React.CSSProperties
  [x: string]: any
}

const ButtonSearch: React.FC<Props> = ({ text, type, disabled, onClick, style, ...rest }) => {
  const { promiseInProgress } = usePromiseTracker()
  const { theme } = useAuth()

  return (
    <Button
      themeType={type ?? 'contained'}
      theme={disabled || promiseInProgress ? 'disabled' : 'clear'}
      disabled={disabled || promiseInProgress}
      onClick={() => (onClick ? onClick() : {})}
      style={
        disabled || promiseInProgress
          ? { ...style }
          : theme === Theme.Dark
          ? { ...style, margin: 2, backgroundColor: '#2E7D32', color: '#FFFFFF' }
          : { ...style, margin: 2, backgroundColor: '#81C784', color: '#212121' }
      }
      {...rest}>
      <TextIconSpacing icon={<FontIcon>search</FontIcon>}>{text ?? 'Pesquisar'}</TextIconSpacing>
    </Button>
  )
}

export default ButtonSearch
